<template>
  <section class="listing">
    <div class="header">
      <div class="title">Atualizações</div>
    </div>
    <form @submit.prevent="getData" class="form form-search">
      <div class="form-inputs">
        <div class="form-inputs-line">
          <input v-model="iniDate" type="date" />
          <input v-model="endDate" type="date" />
          <select v-model="type">
            <option value="profit">Profit</option>
            <option value="ninja">NinjaTrader</option>
          </select>
        </div>
      </div>
      <button type="submit" class="btn-search">
        <i class="fas fa-search"></i>
      </button>
    </form>
    <div class="print-header">
      <div class="print-title">Atualizações</div>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading" style="margin-top: 10px">
        <div class="sum-group">
          <div class="sum">
            <span>Assinantes</span>
            <span>{{ transactions.length }}</span>
          </div>
        </div>
        <div class="list-cards">
        <div v-for="(t, i) in filtered" :key="i" class="list">
          <div class="data">
            <div class="main-data">{{ t.name }}</div>
            <div class="detail-data">{{ type === 'ninja' ? 'NinjaTrader' : t.platform }}</div>
          </div>
          <div class="list-meta">
            <div class="detail-data">{{ t.dates }}</div>
          </div>
        </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll } from '../api/indicators'

export default {
  data () {
    return {
      loading: true,
      transactions: [],
      iniDate: null,
      endDate: null,
      refund: null,
      search: '',
      type: 'profit',
      detail: null,
      transactionsOK: []
    }
  },
  computed: {
    filtered () {
      return this.transactions.filter(x => Object.keys(x).some(key => String(x[key]).toUpperCase().includes(this.search.toUpperCase())))
    }
  },
  watch: {

  },
  async mounted () {
    try {
      const dateIni = new Date()
      const dateFim = new Date()
      dateFim.setMonth(dateFim.getMonth() + 1)
      dateFim.setDate(1)
      dateFim.setDate(dateFim.getDate() - 1)
      this.endDate = dateFim.toISOString().split('T')[0]

      dateIni.setDate(1)
      this.iniDate = dateIni.toISOString().split('T')[0]
      this.getData()
    } catch (error) {
      logger.error(error)
    }
  },
  methods: {
    async getData () {
      this.loading = true
      try {
        this.transactions = await getAll(this.iniDate, this.endDate, this.type)
      } catch (error) {
        logger.error(error)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.print-header {
  display: none;
  justify-content: space-between;
  align-items: center;
  border-bottom: 5px solid $primary-color;
  padding: 20px 15px;
  margin-bottom: 20px !important;
}

.print-title {
  font-size: 2em;
  color: $primary-color;
  font-weight: 500;
}

@media print {
  .admin-router {
    margin: 0;
  }
  .print-header {
    display: block;
  }
  .header, .form-search {
    display: none !important;
  }
  .list {
    page-break-inside: avoid;
    page-break-after: auto;
  }
}
</style>
